export default function ViewButton() {
    return (
        <i className="icon view_icon opacity-50"/>
    )
}